import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { SvgVM } from '../../models/model/concretes/components/svg.model';
import { KeyAmount } from '../../models/interface/concretes/key-amount.interface';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { SvgViewerComponent } from '../svg-viewer/svg-viewer.component';
import { getProductInfo } from '../../constants/product.constants';
import { SummaryOfferState } from 'src/app/core/summary-offer.store';

@Component({
  selector: 'app-price-summary',
  templateUrl: './price-summary.component.html',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, SvgViewerComponent],
})
export class PriceSummaryComponent implements OnInit {
  public resource = inject(AppResource)['resource'];
  store = inject(CombinedStore);

  @Input() showPackagePriceInDetails: boolean = true;
  @Input() showDetails: boolean = true;

  ngOnInit(): void {
    // ACTIVATE STORE SUMMARY
    const productName = getProductInfo(this.store.path())!.name;
    this.svg = new SvgVM(
      `assets/common/offerCustomize/${productName}.svg`,
      'white',
    );
  }

  svg!: SvgVM;

  summary = computed(() => {
    const summary = [] as KeyAmount[];
    const offer = this.store.summaryOffer();
    const productInfo = getProductInfo(this.store.path());


    // // Mock data for testing purposes
    // this.mockOfferPackage(offer);
    // // this.mockOfferOptions(offer);

    // Add base package if available
    // if (offer.package) {
    //   summary.push({
    //     key: `${productInfo?.label || ''}`,
    //     value: String(offer.package.monthlyPremiumAmountIncludingTax!),
    //     display: this.showPackagePriceInDetails,
    //   });
    // }

    // Add options
    if (offer.options && offer.options.length > 0) {
      summary.push(...offer.options.map(option => ({ ...option, display: true })));
    }

    return summary;
  });

  isNumber(value: string): boolean {
    return !isNaN(Number(value));
  }

  summaryAmount = computed(() => {
    // Logic to compute the summary amount
    return this.summary()
      .filter((item) => item.value !== 'Inclus')
      .reduce((total, item) => total + (Number(item.value) ?? 0), 0);
  });

  summaryToDisplay = computed(() => {
    if (!this.showDetails)
      return [];

    return this.summary().filter((item) => item.display);
  });


  private mockOfferPackage(offer: SummaryOfferState): void {
    offer.package = {
      code: 'PKG001',
      text: 'Base Package',
      monthlyPremiumAmountIncludingTax: 0,
      attackTaxAmount: 0,
      comparatorChoice: false,
      urlWarranty: '',
      extraInformations: [],
      optionalCoverages: {},
      coverageDurationInMonths: 12,
      renfCoverages: {}
    };
  }
}
